import React from "react";
import { Download, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminPageHeader({ eyebrow, title, count, onExport, onRefresh, exporting, children }) {
    return (
        <header className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-8">
            <div>
                <p className="font-sans text-xs uppercase tracking-[0.25em] text-caireen-orange">{eyebrow}</p>
                <h1 className="mt-2 font-serif text-4xl md:text-5xl tracking-tight">
                    {title}
                    {typeof count === "number" && (
                        <span className="ml-3 font-sans text-base text-caireen-ink/55 align-middle">({count})</span>
                    )}
                </h1>
                {children}
            </div>
            <div className="flex items-center gap-2">
                {onRefresh && (
                    <Button variant="outline" onClick={onRefresh} className="rounded-full border-caireen-ink/15 font-semibold" data-testid="admin-refresh">
                        <RefreshCw className="w-4 h-4 mr-1.5" />
                        Refresh
                    </Button>
                )}
                {onExport && (
                    <Button
                        onClick={onExport}
                        disabled={exporting}
                        data-testid="admin-export-csv"
                        className="rounded-full bg-caireen-ink hover:bg-caireen-ink/90 text-caireen-cream font-semibold"
                    >
                        <Download className="w-4 h-4 mr-1.5" />
                        Export CSV
                    </Button>
                )}
            </div>
        </header>
    );
}
